import { namespace } from 'wsm-tagging-utils';
import userShouldBeTracked from '../../../userShouldBeTracked';

const runForm = (win) => {
	namespace(win, 'DDC.tracking.framework.runtime');

	const {
		DDC: { tracking },
		newrelic
	} = win;

	/**
	 * The Form class is a collection of form related queries.
	 *
	 * @constructor
	 */
	tracking.framework.runtime.Form = function Form(properties) {
		this.formMapping = new Map();
		this.wsTaggingGrouping = properties && properties.wsTaggingGrouping;
		this.wsTaggingTrackingWidget =
			properties && properties.wsTaggingTrackingWidget;
	};

	tracking.framework.runtime.Form.prototype = {
		/**
		 * The default constructor
		 */
		constructor: win.DDC.tracking.framework.runtime.Form,

		report(name, attributes = {}) {
			if (newrelic) {
				if (userShouldBeTracked()) {
					const { wsTaggingGrouping, wsTaggingTrackingWidget } = this;
					newrelic.addPageAction(name, {
						...attributes,
						wsTaggingGrouping,
						wsTaggingTrackingWidget
					});
				}
			}
		},

		getFormMapping(formTrackingId) {
			this.report('formMappingFunctionStart');
			const startTime = Date.now();

			if (this.formMapping && this.formMapping.has(formTrackingId)) {
				this.report('formMappingFunctionGetCache');
				return Promise.resolve(this.formMapping.get(formTrackingId));
			}

			const mapPromise = new Promise((resolve, reject) => {
				const apiUri = `/api/widget/ws-tagging/${this.wsTaggingTrackingWidget}/${this.wsTaggingGrouping}/${formTrackingId}`;
				fetch(apiUri)
					.then((response) => response.json())
					.then((data) => {
						this.report('formMappingFunctionHitAPI', {
							wsTaggingAPIDuration: Date.now() - startTime
						});
						this.formMapping.set(formTrackingId, data);
						return resolve(this.formMapping.get(formTrackingId));
					})
					.catch((error) => {
						return reject(error);
					});
			});

			return mapPromise;
		}
	};

	/*
	PAGE ACTION

	*/
};

export default runForm;
